module.exports = __webpack_public_path__ + "img/banner_zhCn.5b7ca2b7.png";